import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useCompanyCreation = () => {
  return useMutation({
    mutationFn: async ({
      name,
      email,
      password,
      businessTypeId,
    }: {
      name: string;
      email: string;
      password: string;
      businessTypeId: string;
    }) => {
      try {
        // 1. Create user account
        const { data: authData, error: authError } = await supabase.auth.signUp({
          email,
          password,
          options: {
            data: {
              user_type: "owner",
              company_name: name,
            },
          },
        });

        if (authError) {
          if (authError.message.includes("User already registered")) {
            throw new Error("Un compte existe déjà avec cet email");
          }
          throw authError;
        }

        if (!authData.user) {
          throw new Error("Erreur lors de la création du compte");
        }

        // 2. Create the company with the owner_id set to the new user's ID
        const { data: companyData, error: companyError } = await supabase
          .from("companies")
          .insert([
            {
              name,
              email,
              business_type_id: businessTypeId,
              owner_id: authData.user.id,
            },
          ])
          .select()
          .single();

        if (companyError) {
          console.error("Error creating company:", companyError);
          throw new Error("Erreur lors de la création de l'entreprise");
        }

        return companyData;
      } catch (error: any) {
        console.error("Error in company creation process:", error);
        throw error;
      }
    },
    onError: (error: Error) => {
      toast.error(`Erreur lors de la création de l'entreprise: ${error.message}`);
    },
    onSuccess: () => {
      toast.success("Entreprise créée avec succès! Veuillez vérifier votre email pour confirmer votre compte.");
    },
  });
};